/**
 * Pagina editor processo attività
 * @module Pages/Admin/Processi/Editor
 */

import { useNavigate, useParams } from 'react-router-dom'
import { Button, Flex, Spinner, Text } from '../../../../Components'
import { saveProcesso, useProcesso } from '../Functions'
import { FloatInput } from '../../../Gigi/GigiForm/TransferField/InputForm'
import { useState } from 'react'

export function ProcessoEditor () {
  const { processoId } = useParams()
  const navigate = useNavigate()
  const [processo, setProcesso, isSuccess] = useProcesso(processoId)
  const [checkError, setCheckError] = useState(false)

  const save = async () => {
    setCheckError(true)
    if (!processo?.codice) {
      window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Compila i campi obbligatori' })
      return
    }
    const res = await saveProcesso(processo)
    if (res) navigate('/admin/processi/list')
  }

  const isNew = processoId === 'new'

  if (!isSuccess || !processo) return <Spinner />
  return (
    <Flex fw>
      <Text value={`${isNew ? 'Crea' : 'Modifica'} Processo`} title bold size={30} />
      <Flex fw row wrap style={{ marginTop: 20 }}>
        <Flex style={{ width: '48%', marginRight: '2%' }}>
          <FloatInput
            value={[processo.codice || '', (val) => setProcesso('codice', val)]}
            error={checkError && !processo.codice}
            label='Codice' id='codice'
          />
        </Flex>
        <Flex style={{ width: '48%', marginLeft: '2%' }}>
          <FloatInput
            value={[processo.descrizione || '', (val) => setProcesso('descrizione', val)]}
            label='Descrizione' id='descrizione'
          />
        </Flex>
      </Flex>
      <Flex fw row style={{ marginTop: 30 }}>
        <Button label='Salva' icon='fa-duotone fa-check' style={{ marginRight: 10 }} onClick={save} />
        <Button label='Torna indietro' icon='fa-duotone fa-arrow-left' onClick={() => navigate('/admin/processi/list')} />
      </Flex>
    </Flex>
  )
}
